import Apxor from "apxor";
import CE from "apxor-qe";
import ApxorRTM from "apxor-rtm";
import { APXOR_APP_ID } from "./constant";
import { SESSION_KEYS, getDataFromSession } from "./session-storage";
const { REACT_APP_VERSION } = process.env;
export const addApxor = () => {
    Apxor.init(APXOR_APP_ID, {
        // Initialization options
        plugins: ["ApxorRTM"],
        deps: [ApxorRTM, CE],
        version: REACT_APP_VERSION,
    });
};
export const captureApxorEvent = (eventName, eventProperties) => {
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    Apxor.logEvent(eventName, {
        userId: clientCode,
        value: eventProperties,
        item: "",
    }, false);
};
export const captureApxorPageView = (page) => {
    Apxor.logPageView(page);
};
